import React, {forwardRef} from "react";
import styles from "./PlayButton.module.css";
import {Button} from "../Button/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPause, faVolumeUp} from "@fortawesome/free-solid-svg-icons";


const PlayButton = forwardRef(({ isPlaying, onClick, size="2x", className}, ref) => {

    return (
        <Button className={`${styles.playButtonContainer} ${className}`} onClick={onClick}>
            {isPlaying ? (
                <FontAwesomeIcon
                    className={styles.audio_icon}
                    size={size}
                    icon={faPause}
                />
            ) : (
                <FontAwesomeIcon
                    className={styles.audio_icon}
                    size={size}
                    icon={faVolumeUp}
                />
            )}
        </Button>
    )
});

export default PlayButton;